import React, { useState } from "react";
import {

  TextField,
  Select,
  MenuItem,
  Button,
  FormControlLabel,
  Radio,
} from "@mui/material";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds, FirstAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "حاسبة النوم الصحي - حساب وقت الاستيقاظ أو النوم الصحي";
const DESCRIPTION =
  "استخدم حاسبة النوم الصحي لحساب وقت الاستيقاظ أو النوم بناءً على دورة النوم الخاصة بك أو المدة اللازمة للنوم. اكتشف المزيد أيضًا حول النوم وأهميته لصحتك العامة.";
const KEYWORDS =
  "حاسبة النوم الصحي, دورة النوم, النوم, الصحة, الاستيقاظ, النوم الصحي, مدة النوم";
const OG_URL = "https://do-calculate.com/calculator/ar/sleep/";
const data1 = [
  { ageGroup: "0–3 شهر", recommendedHours: "14–17 ساعة" },
  {
    ageGroup: "4–12 شهر",
    recommendedHours: "12–16  ساعة خلال ال 24 ساعة متضمنة وقت القيلولة",
  },
  {
    ageGroup: "1–2 سنة",
    recommendedHours: "11–14  ساعة خلال ال 24 ساعة متضمنة وقت القيلولة",
  },
  {
    ageGroup: "3–5 سنة",
    recommendedHours: "10–13  ساعة خلال ال 24 ساعة متضمنة وقت القيلولة",
  },
  { ageGroup: "6–12 سنة", recommendedHours: "9–12  ساعة خلال ال 24 ساعة" },
  { ageGroup: "13–18 سنة", recommendedHours: "8–10  ساعة خلال ال 24 ساعة" },
  {
    ageGroup: "18–60 سنة",
    recommendedHours: "7 ساعات أو أكثر في الليلة الواحدة",
  },
  { ageGroup: "61–64 سنة ", recommendedHours: "7-9 ساعات" },
  { ageGroup: "65 سنة وأكثر", recommendedHours: "7–8 ساعات" },
];
function SleapCalculator() {
  const [sleepType, setSleepType] = useState("wakeup");
  const [hours, setHours] = useState("");
  const [minutes, setMinutes] = useState("");
  const [pmAm, setPmAm] = useState("AM");
  const [sleepCycle, setSleepCycle] = useState(90);
  const [takesToSleep, setTakesToSleep] = useState(15);
  const [hoursError, setHoursError] = useState("");
  const [minutesError, setMinutesError] = useState("");
  const [sleepCycleError, setSleepCycleError] = useState("");
  const [takesToSleepError, setTakesToSleepError] = useState("");
  const [result1, setResult1] = useState("");
  const [sleepType2, setSleepType2] = useState("wakeup");
  const [hours2, setHours2] = useState("");
  const [minutes2, setMinutes2] = useState("");
  const [pmAm2, setPmAm2] = useState("AM");
  const [sleepHours, setSleepHours] = useState("");
  const [sleepMinutes, setSleepMinutes] = useState("");
  const [hoursError2, setHoursError2] = useState("");
  const [minutesError2, setMinutesError2] = useState("");
  const [sleepHoursError, setSleepHoursError] = useState("");
  const [sleepMinutesError, setSleepMinutesError] = useState("");
  const [result2, setResult2] = useState("");
  const handleHoursChange = (event) => {
    const inputHours = event.target.value;
    if (inputHours !== "") {
      const parsedHours = parseInt(inputHours, 10);
      if (!isNaN(parsedHours) && parsedHours <= 12) {
        setHours(inputHours);
        setHoursError("");
      } else {
        setHours("");
        if (isNaN(parsedHours)) {
          setHoursError("تأكد من ادخال عدد");
        } else if (parsedHours > 12) {
          setHours(inputHours);
          setHoursError("عدد الساعات  12 ساعة");
        }
      }
    } else {
      setHours("");
      setHoursError("");
    }
  };
  const handleMinutesChange = (event) => {
    const inputMinutes = event.target.value;
    if (inputMinutes !== "") {
      const parsedMinutes = parseInt(inputMinutes, 10);
      if (!isNaN(parsedMinutes) && parsedMinutes <= 60) {
        setMinutes(inputMinutes);
        setMinutesError("");
      } else {
        setMinutes("");
        if (isNaN(parsedMinutes)) {
          setMinutesError("تأكد من ادخال عدد");
        } else if (parsedMinutes > 60) {
          setMinutes(inputMinutes);
          setMinutesError("الدقائق بالساعة 60 دقيقة");
        }
      }
    } else {
      setMinutes("");
      setHoursError("");
    }
  };
  const handleTakesToSleepChange = (event) => {
    const inputTakesToSleep = event.target.value;
    if (inputTakesToSleep !== "") {
      if (!isNaN(inputTakesToSleep)) {
        setTakesToSleep(inputTakesToSleep);
        setTakesToSleepError("");
      } else {
        setTakesToSleep("");
        if (isNaN(inputTakesToSleep)) {
          setTakesToSleepError("تأكد من ادخال عدد");
        }
      }
    } else {
      setTakesToSleep("");
      setTakesToSleepError("");
    }
  };
  const handleSleepCycleChange = (event) => {
    const inputSleepCycle = event.target.value;
    if (inputSleepCycle !== "") {
      if (!isNaN(inputSleepCycle)) {
        setSleepCycle(inputSleepCycle);
        setSleepCycleError("");
      } else {
        setSleepCycle("");
        if (isNaN(inputSleepCycle)) {
          setSleepCycleError("تأكد من ادخال عدد");
        }
      }
    } else {
      setSleepCycle("");
      setSleepCycleError("");
    }
  };
  const handleSubmitCycle = (e) => {
    e.preventDefault();
    if (sleepType === "wakeup") {
      let wakeupHours = parseInt(hours);
      let wakeupMinutes = parseInt(minutes);
      if (pmAm === "PM" && wakeupHours !== 12) {
        wakeupHours += 12;
      }
      if (pmAm === "AM" && wakeupHours === 12) {
        wakeupHours = 0;
      }
      let wakeupTimeMinutes = wakeupHours * 60 + wakeupMinutes;
      const recommendedBedtimes = [];
      const otherBedtimes = [];
      for (let i = 6; i >= 1; i--) {
        let bedtimeMinutes = wakeupTimeMinutes - i * sleepCycle - takesToSleep;
        if (bedtimeMinutes < 0) {
          bedtimeMinutes += 24 * 60;
        }
        let bedtimeHours = Math.floor(bedtimeMinutes / 60);
        let bedtimeMinutesFormatted = bedtimeMinutes % 60;
        let period = "AM";
        if (bedtimeHours >= 12) {
          period = "PM";
          if (bedtimeHours > 12) {
            bedtimeHours -= 12;
          }
        }
        if (bedtimeHours === 0) {
          bedtimeHours = 12;
        }
        const bedtime = {
          hours: bedtimeHours,
          minutes: bedtimeMinutesFormatted,
          period: period,
          cycles: i,
        };
        if (i === 5 || i === 6) {
          recommendedBedtimes.push(bedtime);
        } else {
          otherBedtimes.push(bedtime);
        }
      }
      let resultHTML = `<p>للاستيقاظ منتعشًا في الساعة <b>${hours}:${minutes.padStart(
        2,
        "0"
      )} ${pmAm}</b>، يُوصى بالذهاب إلى النوم في إحدى الأوقات التالية:</p>`;
      recommendedBedtimes.forEach((bedtime) => {
        resultHTML += `<div><b style="color: green;">${bedtime.hours
          }:${bedtime.minutes.toString().padStart(2, "0")} ${bedtime.period} (${bedtime.cycles
          } دورة نوم)</b></div>`;
      });
      resultHTML += `<p>إذا كان لديك ترتيبات مختلفة، يمكنك أيضًا اختيار إحدى الأوقات التالية:</p>`;
      otherBedtimes.forEach((bedtime) => {
        resultHTML += `<div>${bedtime.hours}:${bedtime.minutes
          .toString()
          .padStart(2, "0")} ${bedtime.period} (${bedtime.cycles
          } دورة نوم)</div>`;
      });
      setResult1(resultHTML);
    } else if (sleepType === "goToSleep") {
      let bedtimeHours = parseInt(hours);
      let bedtimeMinutes = parseInt(minutes);
      if (pmAm === "PM" && bedtimeHours !== 12) {
        bedtimeHours += 12;
      }
      if (pmAm === "AM" && bedtimeHours === 12) {
        bedtimeHours = 0;
      }
      let bedtimeTimeMinutes = bedtimeHours * 60 + bedtimeMinutes;
      const recommendedWakeupTimes = [];
      const otherWakeupTimes = [];
      for (let i = 1; i <= 6; i++) {
        let wakeupMinutes = bedtimeTimeMinutes + i * sleepCycle + takesToSleep;
        if (wakeupMinutes >= 24 * 60) {
          wakeupMinutes -= 24 * 60;
        }
        let wakeupHours = Math.floor(wakeupMinutes / 60);
        let wakeupMinutesFormatted = wakeupMinutes % 60;
        let period = "AM";
        if (wakeupHours >= 12) {
          period = "PM";
          if (wakeupHours > 12) {
            wakeupHours -= 12;
          }
        }
        if (wakeupHours === 0) {
          wakeupHours = 12;
        }
        const wakeup = {
          hours: wakeupHours,
          minutes: wakeupMinutesFormatted,
          period: period,
          cycles: i,
        };
        if (i === 5 || i === 6) {
          recommendedWakeupTimes.push(wakeup);
        } else {
          otherWakeupTimes.push(wakeup);
        }
      }
      let result = `<p>إذا ذهبت للنوم في الساعة <b>${hours}:${minutes.padStart(
        2,
        "0"
      )} ${pmAm}</b>، \n يُوصى بالاستيقاظ في إحدى الأوقات التالية للاستيقاظ منتعشًا:</p>\n\n`;
      recommendedWakeupTimes.forEach((wakeup) => {
        result += `<div><b style="color: green;">${wakeup.hours
          }:${wakeup.minutes.toString().padStart(2, "0")} ${wakeup.period} (${wakeup.cycles
          } دورة نوم)</b></div>\n`;
      });
      result += `<p>إذا كان لديك ترتيبات مختلفة، يمكنك أيضًا اختيار إحدى الأوقات التالية:</p>`;
      otherWakeupTimes.forEach((wakeup) => {
        result += `<div>${wakeup.hours}:${wakeup.minutes
          .toString()
          .padStart(2, "0")} ${wakeup.period}\t(${wakeup.cycles
          } دورة نوم)</div>`;
      });
      setResult1(result);
    }
  };
  const onReset1 = () => {
    setSleepType("wakeup");
    setHours("");
    setMinutes("");
    setPmAm("AM");
    setSleepCycle("");
    setTakesToSleep("");
    setHoursError("");
    setMinutesError("");
    setSleepCycleError("");
    setTakesToSleepError("");
    setResult1("");
  };
  const handleHours2Change = (event) => {
    const inputHours = event.target.value;
    if (inputHours !== "") {
      const parsedHours = parseInt(inputHours, 10);
      if (!isNaN(parsedHours) && parsedHours <= 12) {
        setHours2(inputHours);
        setHoursError2("");
      } else {
        setHours2("");
        if (isNaN(parsedHours)) {
          setHoursError2("تأكد من ادخال عدد");
        } else if (parsedHours > 12) {
          setHours2(inputHours);
          setHoursError2("عدد الساعات  12 ساعة");
        }
      }
    } else {
      setHours2("");
      setHoursError2("");
    }
  };
  const handleMinutes2Change = (event) => {
    const inputMinutes = event.target.value;
    if (inputMinutes !== "") {
      const parsedMinutes = parseInt(inputMinutes, 10);
      if (!isNaN(parsedMinutes) && parsedMinutes <= 60) {
        setMinutes2(inputMinutes);
        setMinutesError2("");
      } else {
        setMinutes2("");
        if (isNaN(parsedMinutes)) {
          setMinutesError2("تأكد من ادخال عدد");
        } else if (parsedMinutes > 60) {
          setMinutes2(inputMinutes);
          setMinutesError2("الدقائق بالساعة 60 دقيقة");
        }
      }
    } else {
      setMinutes2("");
      setHoursError2("");
    }
  };
  const handleSleepHoursChange = (event) => {
    const inputSleepCycle = event.target.value;
    if (inputSleepCycle !== "") {
      if (!isNaN(inputSleepCycle)) {
        setSleepHours(inputSleepCycle);
        setSleepHoursError("");
      } else {
        setSleepHours("");
        if (isNaN(inputSleepCycle)) {
          setSleepHoursError("تأكد من ادخال عدد");
        }
      }
    } else {
      setSleepHours("");
      setSleepHoursError("");
    }
  };
  const handleSleepMinutesChange = (event) => {
    const inputTakesToSleep = event.target.value;
    if (inputTakesToSleep !== "") {
      if (!isNaN(inputTakesToSleep)) {
        setSleepMinutes(inputTakesToSleep);
        setSleepMinutesError("");
      } else {
        setSleepMinutes("");
        if (isNaN(inputTakesToSleep)) {
          setSleepMinutesError("تأكد من ادخال عدد");
        }
      }
    } else {
      setSleepMinutes("");
      setSleepMinutesError("");
    }
  };
  const handleSubmitLength = (e) => {
    e.preventDefault();
    if (sleepType2 === "wakeup") {
      const wakeUpHour = parseInt(hours2, 10);
      const wakeUpMinute = parseInt(minutes2, 10);
      const sleepHour = parseInt(sleepHours, 10);
      const sleepMinute = parseInt(sleepMinutes, 10);
      let bedHour = wakeUpHour - sleepHour;
      let bedMinute = wakeUpMinute - sleepMinute;
      let updatedPmAm2 = pmAm2;
      if (bedMinute < 0) {
        bedHour -= 1;
        bedMinute += 60;
      }
      if (bedHour < 0) {
        bedHour += 12;
        updatedPmAm2 = pmAm2 === "AM" ? "PM" : "AM";
      }
      const result = `<div>يجب أن تذهب إلى السرير في: <b  style="color: green;">${bedHour}:${bedMinute
        .toString()
        .padStart(2, "0")} ${updatedPmAm2}</b></div>`;
      setResult2(result);
    } else if (sleepType2 === "goToSleep") {
      const sleepHour = parseInt(hours2, 10);
      const sleepMinute = parseInt(minutes2, 10);
      const wakeUpHour = parseInt(sleepHours, 10);
      const wakeUpMinute = parseInt(sleepMinutes, 10);
      let updatedPmAm2 = pmAm2;
      let wakeHour = wakeUpHour + sleepHour;
      let wakeMinute = wakeUpMinute + sleepMinute;
      if (wakeMinute >= 60) {
        wakeHour += 1;
        wakeMinute -= 60;
      }
      if (wakeHour >= 12) {
        wakeHour -= 12;
        updatedPmAm2 = pmAm2 === "AM" ? "PM" : "AM";
      }
      const result = `يجب أن تستيقظ في<div>: <b  style="color: green;">${wakeHour}:${wakeMinute
        .toString()
        .padStart(2, "0")} ${updatedPmAm2}</b></div>`;
      setResult2(result);
    }
  };
  const onReset2 = () => {
    setSleepType2("wakeup");
    setHours2("");
    setMinutes2("");
    setPmAm2("AM");
    setSleepHours("");
    setSleepMinutes("");
    setHoursError2("");
    setMinutesError2("");
    setSleepHoursError("");
    setSleepMinutesError("");
    setResult2("");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  استخدم حاسبة النوم الصحي لحساب وقت الاستيقاظ أو النوم بناءً
                  على دورة النوم الخاصة بك أو المدة اللازمة للنوم. يقدم لك
                  الأداة توقعاتًا لأوقات النوم المناسبة بناءً على دورة نومك
                  الطبيعية ومدة النوم الموصى بها لصحتك. بالإضافة إلى ذلك، توفر
                  لك المعلومات القيمة حول الأنماط الصحية للنوم وأثرها على جودة
                  الحياة والصحة العامة، مما يساعدك في فهم أهمية النوم الصحي
                  وتبني عادات نوم صحية.
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds />
            <div className="row">
              <div className="col-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  حاسبة دورة النوم
                </div>
                <hr />
                <form onSubmit={handleSubmitCycle}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", marginBottom: "16px" }}>
                    <b><label>اريد ان</label></b>
                    <div style={{ display: "flex", gap: "24px", marginTop: "8px" }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <input
                          type="radio"
                          value="wakeup"
                          checked={sleepType === "wakeup"}
                          onChange={(e) => setSleepType(e.target.value)}
                        />
                        استيقظ بالوقت
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <input
                          type="radio"
                          value="goToSleep"
                          checked={sleepType === "goToSleep"}
                          onChange={(e) => setSleepType(e.target.value)}
                        />
                        انام بالوقت
                      </label>
                    </div>
                  </div>

                  <div className="mb-3 d-flex" style={{ alignItems: "flex-end", gap: "10px" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>ساعة</label>
                      <select
                        value={hours}
                        onChange={handleHoursChange}
                        required
                        className="form-control"
                        style={{ width: "80px" }}
                      >
                        {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => (
                          <option key={h} value={h}>{h}</option>
                        ))}
                      </select>
                    </div>
                    <span style={{ marginBottom: "8px" }}>:</span>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>دقيقة</label>
                      <select
                        value={minutes}
                        onChange={handleMinutesChange}
                        required
                        className="form-control"
                        style={{ width: "80px" }}
                      >
                        {Array.from({ length: 60 }, (_, i) => i).map((m) => (
                          <option key={m} value={m}>{String(m).padStart(2, "0")}</option>
                        ))}
                      </select>
                    </div>
                    <span style={{ marginBottom: "8px" }}>:</span>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>ص/م</label>
                      <select
                        value={pmAm}
                        onChange={(e) => setPmAm(e.target.value)}
                        className="form-control"
                        style={{ width: "80px", fontSize: "14px" }}
                      >
                        <option value="AM">صباحاً</option>
                        <option value="PM">مساءً</option>
                      </select>
                    </div>
                  </div>

                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <span>طول دورة نومي هي</span>
                    <input
                      placeholder="30"
                      value={sleepCycle}
                      onChange={handleSleepCycleChange}
                      required
                      className="form-control d-inline-block"
                      style={{ width: "80px", margin: "0 5px" }}
                    />
                    <span>دقيقة</span>
                    <br />

                  </div>
                  <div className="mb-3 d-flex" style={{ alignItems: "center" }}>
                    <span>إحتاج إلى</span>
                    <input
                      placeholder="30"
                      value={takesToSleep}
                      onChange={handleTakesToSleepChange}
                      required
                      className="form-control d-inline-block"
                      style={{ width: "100px", margin: "0 5px" }}
                    />
                    <span>دقيقة للنوم</span>
                  </div>
                  <hr />

                  <div className="mb-3">
                    <button type="submit" className="btn btn-success" style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }}>
                      احسب
                    </button>
                    <button type="button" className="btn btn-secondary" style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }} onClick={onReset1}>
                      امسح النتيجة
                    </button>
                  </div>
                </form>
              </div>
              <br />
              <div className="col-12 col-md-6">
                {result1 && (
                  <div dangerouslySetInnerHTML={{ __html: result1 }} />
                )}
              </div>
            </div>
            <hr />
            <br />
            <div className="row">
              <div className="col-12 col-md-6 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  حاسبة طول النوم
                </div>
                <hr />
                <br />
                <form onSubmit={handleSubmitLength}>
                  <div style={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", marginBottom: "16px" }}>
                    <b><label>اريد ان</label></b>
                    <div style={{ display: "flex", gap: "24px", marginTop: "8px" }}>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <input
                          type="radio"
                          value="wakeup"
                          checked={sleepType2 === "wakeup"}
                          onChange={(e) => setSleepType2(e.target.value)}
                        />
                        استيقظ بالوقت
                      </label>
                      <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <input
                          type="radio"
                          value="goToSleep"
                          checked={sleepType2 === "goToSleep"}
                          onChange={(e) => setSleepType2(e.target.value)}
                        />
                        انام بالوقت
                      </label>
                    </div>
                  </div>
                  <div className="mb-3 d-flex" style={{ alignItems: "flex-end", gap: "10px" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>ساعة</label>
                      <select
                        value={hours2}
                        onChange={handleHours2Change}
                        required
                        className="form-control"
                        style={{ width: "80px" }}
                      >
                        {Array.from({ length: 12 }, (_, i) => i + 1).map((h) => (
                          <option key={h} value={h}>{h}</option>
                        ))}
                      </select>
                    </div>
                    <span style={{ marginBottom: "8px" }}>:</span>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>دقيقة</label>
                      <select
                        value={minutes2}
                        onChange={handleMinutes2Change}
                        required
                        className="form-control"
                        style={{ width: "80px" }}
                      >
                        {Array.from({ length: 60 }, (_, i) => i).map((m) => (
                          <option key={m} value={m}>{String(m).padStart(2, "0")}</option>
                        ))}
                      </select>
                    </div>
                    <span style={{ marginBottom: "8px" }}>:</span>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>ص/م</label>
                      <select
                        value={pmAm2}
                        onChange={(e) => setPmAm2(e.target.value)}
                        className="form-control"
                        style={{ width: "80px", fontSize: "14px" }}
                      >
                        <option value="AM">صباحاً</option>
                        <option value="PM">مساءً</option>
                      </select>
                    </div>
                  </div>

                  <b><label>اريد النوم ل</label></b>
                  <div className="mb-3 d-flex" style={{ alignItems: "flex-end", gap: "10px" }}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>ساعة</label>
                      <select
                        value={sleepHours}
                        onChange={handleSleepHoursChange}
                        required
                        className="form-control"
                        style={{ width: "130px" }}
                      >
                        {Array.from({ length: 13 }, (_, i) => i).map((h) => (
                          <option key={h} value={h}>{h}</option>
                        ))}
                      </select>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <label style={{ fontSize: "13px", marginBottom: "4px" }}>دقيقة</label>
                      <select
                        value={sleepMinutes}
                        onChange={handleSleepMinutesChange}
                        required
                        className="form-control"
                        style={{ width: "140px" }}
                      >
                        {Array.from({ length: 60 }, (_, i) => i).map((m) => (
                          <option key={m} value={m}>{String(m).padStart(2, "0")}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <hr />

                  <div className="mb-3">
                    <button type="submit" className="btn btn-success" style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }}>
                      احسب
                    </button>
                    <button type="button" className="btn btn-secondary" style={{ marginRight: "25px", padding: "5px 25px", fontSize: "15px" }} onClick={onReset2}>
                      امسح النتيجة
                    </button>
                  </div>
                </form>
              </div>
              <div className="col-12 col-md-6">
                {result2 && (
                  <div dangerouslySetInnerHTML={{ __html: result2 }} />
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                كل ما تحتاج لمعرفته حول النوم: كيفية حسابه وأهميته في نظامك
                اليومي
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>دورات النوم</h2>
                </u>
                <br />
                <p>
                  يمكن تعريف دورة النوم على أنها التذبذب بين حركة العين السريعة
                  (حركة العين السريعة) ونوم حركة العين السريعة، والتي سيتم
                  مناقشتها أدناه. يعتمد توقيت النوم إلى حد كبير على الإشارات
                  الهرمونية من الساعة البيولوجية. تُظهر الساعة البيولوجية
                  إيقاعًا منتظمًا يتوافق مع الإشارات الخارجية (مثل الليل/النهار)
                  والتي يمكن أن تستمر حتى لو اختفت الإشارات الخارجية فجأة. مثال
                  على ذلك هو اضطراب الرحلات الجوية الطويلة، حيث يتأثر إيقاع
                  الساعة البيولوجية للجسم بسبب السفر السريع لمسافات طويلة، مما
                  يؤدي إلى عدم توافق المسافر مع التوقيت المحلي. يشعر المسافر بعد
                  ذلك أنه إما متأخر أو أبكر عما اعتاد عليه جسمه، مما يؤثر على
                  نومه. من الناحية المثالية، تتبع دورة نوم الشخص الساعة
                  البيولوجية، ولكن يمكن أن يتأثر النوم بعوامل عديدة مثل الضوء،
                  والتوقيت الاجتماعي (عندما يكون الآخرون مستيقظين، عندما يكون
                  العمل مطلوبًا، وما إلى ذلك)، والقيلولة، وعلم الوراثة، وأكثر من
                  ذلك.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>REM و non-REM sleep</h2>{" "}
                </u>{" "}
                <br />
                <p>
                  أثناء النوم، ينفق الدماغ طاقة أقل بكثير مما ينفقه عندما يكون
                  الشخص مستيقظًا، خاصة أثناء نوم حركة العين السريعة. نوم حركة
                  العين السريعة هو نوع من النوم يتميز بعدد من الجوانب، بما في
                  ذلك حركات العين التي سمي باسمها، والشلل الافتراضي للجسم، وحدوث
                  الأحلام. نوم غير حركة العين السريعة ونوم حركة العين السريعة
                  هما فئتان من النوم مختلفتان إلى حد كبير.
                  <br /> عادة، يدور الجسم بين نوم حركة العين غير السريعة ونوم
                  حركة العين السريعة على مدار فترة 90 دقيقة في المتوسط، ويجب أن
                  تحدث 4-6 مرات أثناء نوم جيد ليلاً. يبدأ نوم غير حركة العين
                  السريعة، وينتقل في النهاية إلى نوم الموجة البطيئة، أو النوم
                  العميق. خلال هذه الفترة، تنخفض درجة حرارة الجسم ومعدل ضربات
                  القلب، ويستخدم الدماغ طاقة أقل بكثير، بينما يستعيد إمداده من
                  الأدينوسين ثلاثي الفوسفات (ATP)، وهو جزيء يستخدم لتخزين ونقل
                  الطاقة. أثناء نوم الموجة البطيئة، يتم أيضًا إفراز هرمون النمو،
                  وهو أمر مهم بشكل خاص لنمو الإنسان. <br /> عادةً ما يشتمل نوم
                  حركة العين السريعة على نسبة أقل من وقت النوم، ويُعرف على
                  الأرجح بأنه يحدث عندما تحدث الأحلام أو الكوابيس عادةً. يمكن أن
                  يؤدي الحرمان من نوم حركة العين السريعة إلى القلق والتهيج
                  والهلوسة وصعوبة التركيز. أظهرت الدراسات أنه عندما يُحرم الجسم
                  من نوم حركة العين السريعة، فإن النوم اللاحق سيتضمن زيادة عدد
                  محاولات الجسم للدخول في نوم حركة العين السريعة، بالإضافة إلى
                  زيادة في مقدار الوقت الذي يقضيه في نوم حركة العين السريعة
                  مقارنة بفترات عدم الحرمان من النوم. . ويشار إلى هذا باسم
                  ارتداد حركة العين السريعة، وهو يتوافق مع الاعتقاد بأن نوم حركة
                  العين السريعة ضروري للجسم. نوم حركة العين السريعة وآثاره
                  وضرورته لا تزال غير مفهومة بشكل كامل، وعلى الرغم من أنه يعتبر
                  جانبًا مهمًا وضروريًا للنوم، إلا أنه في بعض الحالات، يمكن أن
                  يكون للحرمان من نوم حركة العين السريعة آثار إيجابية عابرة.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>نوعية النوم</h2>
                </u>
                <br />
                <p>
                  يمكن قياس جودة النوم من حيث درجة الصعوبة التي يواجهها الشخص في
                  النوم والاستمرار فيه، بالإضافة إلى عدد المرات التي يستيقظ فيها
                  الشخص عادةً في ليلة واحدة. ويمكن أيضًا قياسها بشكل أكثر ذاتية
                  من حيث مدى شعور الشخص بالراحة عند الاستيقاظ. يؤدي ضعف نوعية
                  النوم إلى تعطيل دورة النوم والانتقالات بين مراحل النوم
                  المختلفة. من أجل الحصول على نوعية نوم جيدة، يجب أن تكون الحاجة
                  إلى النوم متوازنة مع عنصر النوم اليومي. من الناحية المثالية،
                  يجب أن يكون توقيت النوم متوازنًا بحيث يحدث الحد الأقصى لتركيز
                  هرمون الميلاتونين والحد الأدنى لدرجة حرارة الجسم الأساسية بعد
                  منتصف فترة النوم وقبل الاستيقاظ.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    ما مقدار النوم الذي أحتاجه؟
                  </h2>
                </u>
                <br />
                <p>
                  النوم ليس مفهومًا تمامًا، ويمكن أن يختلف مقدار النوم الذي
                  يحتاجه الشخص إلى حد كبير بناءً على مقاييس معينة، مثل العمر،
                  وكذلك بشكل فردي تمامًا. يجب على الشخص الذي ينام كمية كافية ألا
                  يعاني من النعاس أو الخلل الوظيفي أثناء النهار. بشكل عام، وجد
                  الباحثون أن الحصول على 6-7 ساعات من النوم في الليلة يرتبط بعدد
                  من النتائج الصحية الإيجابية، ولكن هناك أيضًا العديد من العوامل
                  الأخرى التي قد تؤثر على هذه النتائج. مع تقدم الشخص في العمر،
                  يميل إلى النوم أقل، حيث ينام الأطفال حديثي الولادة لساعات أطول
                  بكثير من البالغين. يتناقص هذا التناقض مع تقدم العمر، وتصبح
                  متطلبات النوم أكثر تشابهًا مع متطلبات البالغين بدءًا من سن
                  الخامسة تقريبًا. فيما يلي توصيات مراكز مكافحة الأمراض والوقاية
                  منها (CDC) لعدد الساعات التي يجب أن ينامها الشخص بناءً على
                  عمره.
                </p>
                <hr />
              </div>
            </div>
          </div>
          <br />
          <u>
            <h2>بعض الجداول التوضيحية :</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  ساعات النوم الموصى بها يوميا :
                </h3>
              </div>
              <div className="info-section-body">
                <table>
                  <thead>
                    <tr>
                      <th>ساعات النوم الموصى بها يوميا (hours)</th>
                      <th>الفئة العمرية (Years)</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data1.map((row) => (
                      <tr key={row.ageGroup}>
                        <td>{row.recommendedHours}</td>
                        <td>{row.ageGroup}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default SleapCalculator;
